import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

// material-ui icons
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

// IMPORT FUNCTIONS
import getUrl from  "../../../../utils/functions/getUrl";


const Modal = ( { closeModal, imageData }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  const [imgs] = useState(BASE_URL + '/uploaded/imgs/');

  const [image, setImage] = useState(null);


  useEffect(()=>{
    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network) {
      console.log('LOCALE!!!');

      setImage({
        "id": "9999",
        "img_name": "wonderful-woman.jpg",
        "img_mini_name": "wonderful-woman_mini.jpeg"
      });

    } else {
      setImage(imageData);
    }

  },[]);
  

  return (
    <Wrapper>
      <Container>
        {
          image && 
          <>
            <ContainerTop>
              <CloseBtn onClick={()=>closeModal(false)}><HighlightOffIcon sx={{ fontSize: 30 }}/></CloseBtn>
              <Title>{image.img_name}</Title>
            </ContainerTop>
            <Content>
              <img src={imgs + image.img_name} alt={image.img_name} />
            </Content>
          </>
        }
      </Container>
    </Wrapper>
  )
}

export default Modal;


const Wrapper = styled.div `

  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .85);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div `
  width: 90vw;
  max-height: 95vh; 
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .8);
  border: 1px solid orange;
  padding: .5rem 1rem 1rem;
  /* margin-top: 10vh; */
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;

const ContainerTop = styled.div `
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  max-height: 5vh;

  @media screen AND (max-width: 600px) {
    max-height: 20vh;
    align-items: flex-start;
    margin-top: 20px;
  }
  
`;
const CloseBtn = styled.div `
  align-self: flex-end;
  /* border: 1px solid orange; */

`;

const Title = styled.div `
  /* text-transform: capitalize; */
  font-size: 1.1rem;
  /* border: 1px solid orange; */

  span {
    color: orange;
  }

  @media screen AND (max-width: 600px) {
    font-size: .8rem;
  }
`;

const Content = styled.div `
  margin-top: 2rem;
  text-align: center;
  text-transform: capitalize;
  font-size: 1.8rem;
  width: 100%;
  max-height: 80vh;
  /* border: 1px solid orange; */

  img {
    max-width: 100%;
    max-height: 80vh;
  }

  @media screen AND (max-width: 600px) {
      margin-top: .5rem;
  }
`;

const Message = styled.div `
  font-size: 1rem;
  color: red;
  line-height: 1.6rem;
`;


const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  font-size: 1.2rem;
  margin-top: 1rem;
  width: 100%;
  text-transform: uppercase;
`;

const CancelBtn = styled.div `
  /* border: 1px solid orange; */
  border-radius: 3px;
  padding: .3rem .6rem;
`;
const SaveBtn = styled.div `
  border: 1px solid orange;
  border-radius: 3px;
  padding: .3rem .6rem;
`;